import { Box, Link } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Form } from "@samdesk/components/Form";
import { Heading } from "@samdesk/components/Heading";
import { InputEmail } from "@samdesk/components/InputEmail";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import { type FieldValues } from "react-hook-form";
import { Link as RouterLink } from "react-router-dom";
import { linkSx, wrapperSx } from "router/authStyles";

interface Props {
	handleCreateResetPasswordRequest: (data: FieldValues) => void;
}

const RequestResetPassword = ({ handleCreateResetPasswordRequest }: Props) => {
	return (
		<Box sx={wrapperSx}>
			<Stack spacing="large">
				<Stack spacing="base">
					<Heading level="1">Reset password</Heading>
					<Text align="start" prominence="secondary">
						Enter your email below and we'll send you a link to reset your
						password.
					</Text>
				</Stack>

				<Form onSubmit={handleCreateResetPasswordRequest}>
					<Stack spacing="large">
						<InputEmail
							autoComplete="email"
							label="Email"
							name="email"
							rules={{ required: "Email is required" }}
						/>
						<Button
							fullWidth
							label="Reset password"
							prominence="primary"
							submit
						/>
					</Stack>
				</Form>

				<Stack alignItems="center">
					<Link
						component={RouterLink}
						replace
						sx={linkSx}
						to="/signin"
						underline="none"
					>
						I remember my password
					</Link>
				</Stack>
			</Stack>
		</Box>
	);
};

export default RequestResetPassword;
